import { render } from "./StockTransfer.vue?vue&type=template&id=fe535846"
import script from "./StockTransfer.vue?vue&type=script&lang=js"
export * from "./StockTransfer.vue?vue&type=script&lang=js"

import "./StockTransfer.vue?vue&type=style&index=0&id=fe535846&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__